import { IsNumber } from 'class-validator';

export class AisUpdateAllResponseDto {
  @IsNumber()
  totalProcessed: number;

  @IsNumber()
  successfulUpdates: number;

  @IsNumber()
  failedUpdates: number;
}
